import React, { useState, useRef, useEffect } from 'react';
import './Alumni.css';

const alumniData = [
  {
    id: 1,
    name: 'Dr. Manishekhar Kumar',
    position: 'Assistant Professor (Grade - I)',
    affiliation: 'NIT Raipur, Chhattisgarh, India',
    email: 'manishekhar034@gmail.com',
    linkedin: 'https://www.linkedin.com/in/manishekhar-kumar-09218b106/',
    category: 'faculty',
    degree: 'PhD',
    color: '#5a2d82',
  },
  {
    id: 2,
    name: 'Dr. Jadi Praveen Kumar',
    position: 'Postdoctoral Research Associate',
    affiliation: 'Duke University, USA',
    email: null,
    linkedin: null,
    category: 'postdoc',
    degree: 'PhD',
    color: '#3a6b8c',
  },
  {
    id: 3,
    name: 'Dr. Dimple Chouhan',
    position: 'Postdoctoral Research Fellow',
    affiliation: 'University of Pennsylvania Perelman School of Medicine, USA',
    email: null,
    linkedin: 'https://www.linkedin.com/in/dimple-chouhan-4883b582/',
    category: 'postdoc',
    degree: 'PhD',
    color: '#5a7b25',
  },
  {
    id: 4,
    name: 'Dr. Ankit Gangrade',
    position: 'Research Associate',
    affiliation: 'University of Colorado Boulder, USA',
    email: 'gangradeankit89@gmail.com',
    linkedin: 'https://www.linkedin.com/in/ankit-gangrade-03b36742/',
    category: 'research',
    degree: 'PhD',
    color: '#7b4a25',
  },
  {
    id: 5,
    name: 'Dr. Shreya Mehrotra',
    position: 'DST INSPIRE Faculty',
    affiliation: 'IIT Kanpur, India',
    email: null,
    linkedin: 'https://www.linkedin.com/in/shreya-mehrotra-34892955/',
    category: 'faculty',
    degree: 'PhD',
    color: '#5a7b25',
  },
  {
    id: 6,
    name: 'Dr. Bibhas Kumar Bhunia',
    position: 'Assistant Professor',
    affiliation: 'Parul University, Vadodara, India',
    email: null,
    linkedin: 'https://www.linkedin.com/in/dr-bibhas-kumar-bhunia-470847b/',
    category: 'faculty',
    degree: 'PhD',
    color: '#5a7b25',
  },
  {
    id: 7,
    name: 'Dr. Yogendra Pratap Singh',
    position: 'Assistant Professor',
    affiliation: 'VIT Vellore, India',
    email: 'yogi13160@gmail.com',
    linkedin: 'https://www.linkedin.com/in/yogendra-pratap-singh-2ba55825',
    category: 'faculty',
    degree: 'PhD',
    color: '#254a7b',
  },
  {
    id: 8,
    name: 'Dr. Prerak Gupta',
    position: 'Assistant Professor',
    affiliation: 'National Insititue of Technology Bhopal',
    email: 'prerakgupta@gmail.com',
    linkedin: null,
    category: 'postdoc',
    degree: 'PhD',
    color: '#2d6e5a',
  },
  {
    id: 9,
    name: 'Dr. Joseph Christakiran Moses',
    position: 'Postdoctoral Associate',
    affiliation: 'Penn State University, USA',
    email: null,
    linkedin: 'https://www.linkedin.com/in/joseph-christakiran-moses/',
    category: 'postdoc',
    degree: 'PhD',
    color: '#7b253c',
  },
  {
    id: 10,
    name: 'Dr. Janani G',
    position: 'Postdoctoral Associate',
    affiliation: 'Cornell University, Ithaca, New York, USA',
    email: 'drjananiguru@gmail.com',
    linkedin: 'https://www.linkedin.com/in/dr-janani-guru-53ab201b',
    category: 'postdoc',
    degree: 'PhD',
    color: '#82432d',
  },
  {
    id: 11,
    name: 'Dr. Ashutosh Bandyopadhyay',
    position: 'Research Engineer I',
    affiliation: 'Houston Methodist Research Institute, USA',
    email: 'ashutoshasb@gmail.com',
    linkedin: 'https://www.linkedin.com/in/bandyopadhyayashutosh',
    category: 'research',
    degree: 'PhD',
    color: '#2d5a82',
  },
  {
    id: 12,
    name: 'Dr. Bibrita Bhar',
    position: 'Postdoctoral Associate',
    affiliation: 'L V Prasad Eye Institute, India',
    email: 'hbibrita@gmail.com',
    linkedin: null,
    category: 'postdoc',
    degree: 'PhD',
    color: '#5a7b25',
  },
  {
    id: 13,
    name: 'Dr. Chitra Jaiswal',
    position: 'Post Doc',
    affiliation: 'DGIST, South Korea',
    email: null,
    linkedin: null,
    category: 'research',
    degree: 'PhD',
    color: '#6b4a8c',
  },
  {
    id: 14,
    name: 'Dr. Souradeep Dey',
    position: 'Post Doc',
    affiliation: 'Standford University, USA',
    email: 'deepdey1994@gmail.com',
    linkedin: 'https://www.linkedin.com/in/souradeep-dey-9681081352/',
    category: 'research',
    degree: 'PhD',
    color: '#2d5a82',
  },
];

/* ─── Category Config ─── */
const categoryConfig = {
  all: { label: 'All Alumni', icon: '👥' },
  faculty: { label: 'Faculty Positions', icon: '🎓' },
  postdoc: { label: 'Postdoctoral Researchers', icon: '🔬' },
  research: { label: 'Research Scientists & Engineers', icon: '⚙️' },
};

/* ─── Helper: extract initials ─── */
const getInitials = (name) => {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/* ─── Helper: normalize LinkedIn URL ─── */
const normalizeLinkedIn = (url) => {
  if (!url) return null;
  if (url.startsWith('http')) return url;
  if (url.startsWith('www.')) return `https://${url}`;
  return `https://www.linkedin.com/in/${url}`;
};

/* ─── Helper: get country flag emoji from affiliation ─── */
const getCountryFlag = (affiliation) => {
  const lower = affiliation.toLowerCase();
  if (lower.includes('usa') || lower.includes('ann arbor') || lower.includes('new york') || lower.includes('boulder') || lower.includes('houston') || lower.includes('michigan') || lower.includes('cornell') || lower.includes('colorado'))
    return '🇺🇸';
  if (lower.includes('india') || lower.includes('vellore') || lower.includes('raipur') || lower.includes('prasad'))
    return '🇮🇳';
  return '🌍';
};

const Alumni = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [hoveredCard, setHoveredCard] = useState(null);
  const gridRef = useRef(null);

  const filteredAlumni =
    activeFilter === 'all'
      ? alumniData
      : alumniData.filter((a) => a.category === activeFilter);

  /* Unique stats */
  const totalAlumni = alumniData.length;
  const uniqueInstitutions = [...new Set(alumniData.map((a) => a.affiliation))].length;
  const countriesSet = new Set();
  alumniData.forEach((a) => {
    const flag = getCountryFlag(a.affiliation);
    countriesSet.add(flag);
  });
  const countriesCount = countriesSet.size;

  return (
    <div className="alumni-page_alumni">
      <div className="alumni-container_alumni">
        {/* ─── Breadcrumb ─── */}
        <nav className="breadcrumb_alumni">
          <span className="breadcrumb-link_alumni">Home</span>
          <span className="breadcrumb-sep_alumni">»</span>
          <span className="breadcrumb-current_alumni">Alumni</span>
        </nav>

        {/* ─── Header Section ─── */}
        <header className="alumni-header_alumni">
          <h1 className="page-title_alumni">Our Alumni</h1>
          <p className="page-intro_alumni">
            Alumni of the BBM Lab have established successful careers across academia, industry 
            and leading research institutions worldwide. Our network spans prestigious universities 
            and organizations, underscoring the lab’s dedication to nurturing the next generation of 
            scientists and engineers in the field of biomaterials and tissue engineering.</p>
        </header>

        {/* ─── Stats Bar ─── */}
        <div className="stats-bar_alumni">
          <div className="stat-item_alumni">
            <span className="stat-number_alumni">{totalAlumni}</span>
            <span className="stat-label_alumni">Alumni</span>
          </div>
          <div className="stat-divider_alumni" />
          <div className="stat-item_alumni">
            <span className="stat-number_alumni">{uniqueInstitutions}</span>
            <span className="stat-label_alumni">Institutions</span>
          </div>
          <div className="stat-divider_alumni" />
          <div className="stat-item_alumni">
            <span className="stat-number_alumni">{countriesCount}</span>
            <span className="stat-label_alumni">{countriesCount === 1 ? 'Country' : 'Countries'}</span>
          </div>
        </div>

        {/* ─── Filter Tabs ─── */}
        <div className="filter-bar_alumni">
          {Object.entries(categoryConfig).map(([key, { label }]) => (
            <button
              key={key}
              className={`filter-btn_alumni ${activeFilter === key ? 'active_alumni' : ''}`}
              onClick={() => setActiveFilter(key)}
            >
              {label}
              {key !== 'all' && (
                <span className="filter-count_alumni">
                  {alumniData.filter((a) => a.category === key).length}
                </span>
              )}
            </button>
          ))}
        </div>

        {/* ─── Alumni Grid ─── */}
        <div className="alumni-grid_alumni" ref={gridRef}>
          {filteredAlumni.map((alumni, index) => (
            <article
              key={alumni.id}
              className={`alumni-card_alumni ${hoveredCard === alumni.id ? 'hovered_alumni' : ''}`}
              onMouseEnter={() => setHoveredCard(alumni.id)}
              onMouseLeave={() => setHoveredCard(null)}
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              {/* Top accent bar */}
              <div
                className="card-accent_alumni"
                style={{ background: alumni.color }}
              />

              <div className="card-body_alumni">
                {/* Avatar */}
                <div className="avatar-section_alumni">
                  <div
                    className="avatar_alumni"
                    style={{ background: alumni.color }}
                  >
                    <span className="avatar-initials_alumni">
                      {getInitials(alumni.name)}
                    </span>
                  </div>
                </div>

                {/* Info */}
                <div className="info-section_alumni">
                  <h3 className="alumni-name_alumni">{alumni.name}</h3>
                  <p className="alumni-position_alumni">{alumni.position}</p>
                  <p className="alumni-affiliation_alumni">
                    <span className="affiliation-flag_alumni">
                      {getCountryFlag(alumni.affiliation)}
                    </span>
                    {alumni.affiliation}
                  </p>
                </div>

                {/* Category Badge */}
                <div className="badge-row_alumni">
                  <span className={`category-badge_alumni badge-${alumni.category}_alumni`}>
                    {alumni.category === 'faculty' && 'Faculty'}
                    {alumni.category === 'postdoc' && 'Postdoc'}
                    {alumni.category === 'research' && 'Research'}
                  </span>
                </div>

                {/* Actions */}
                <div className="actions-row_alumni">
                  <a
                    href={`mailto:${alumni.email}`}
                    className="action-btn_alumni email-btn_alumni"
                    title={`Email ${alumni.name}`}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="4" width="20" height="16" rx="2" />
                      <path d="M22 4L12 13L2 4" />
                    </svg>
                    <span>Email</span>
                  </a>

                  {normalizeLinkedIn(alumni.linkedin) ? (
                    <a
                      href={normalizeLinkedIn(alumni.linkedin)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-btn_alumni linkedin-btn_alumni"
                      title={`${alumni.name} on LinkedIn`}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                      </svg>
                      <span>LinkedIn</span>
                    </a>
                  ) : (
                    <span className="action-btn_alumni disabled-btn_alumni">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" opacity="0.3">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                      </svg>
                      <span>LinkedIn</span>
                    </span>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* ─── Bottom CTA ─── */}
        <div className="alumni-cta_alumni">
          <div className="cta-inner_alumni">
            <h3 className="cta-title_alumni">Are you a Mandal Lab alumnus?</h3>
            <p className="cta-text_alumni">
              If you were part of the Mandal Lab and would like to be featured on this page,
              we'd love to hear from you and learn about your journey.
            </p>
            <a
              href="mailto:biman.mandal@iitg.ac.in?subject=Alumni%20Update%20-%20Mandal%20Lab"
              className="cta-btn_alumni"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Alumni;